import { isNil } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import SessionDeatils from 'components/PreClass/Checklist/components/Details/Session'
import Troubleshoot from 'components/PreClass/Checklist/components/Troubleshoot'
import { checklistEventEmitter, checklistKeys } from 'helpers/events'
import { dispatchChecks } from 'store/dispatcher'
import { _checklistStatus, _checklistError } from 'store/selectors/Checklist'
import { _userId, _userType } from 'store/selectors/User'
import { isMobileOrIPad } from 'utils/device'

import AVPermissionModal from './components/AVPermission'
import ParticipantDetails from './components/Details/Participant'
import useActiveParticipants from './hooks/useActiveParticipants'
import useProfileSaver from './hooks/useProfileSaver'
import { Container } from './styles'

const Checklist = () => {
    const err = useSelector(_checklistError)
    const status = useSelector(_checklistStatus)
    const userType = useSelector(_userType)
    const userId = useSelector(_userId)
    const participants = useActiveParticipants()

    const [openAVPermission, setOpenAVPermission] = useState()

    useEffect(() => {
        ;(async () => {
            const shouldAskForPermissions = await dispatchChecks({ userType })
            setOpenAVPermission(shouldAskForPermissions)
        })()
    }, [userType])

    useEffect(() => {
        if (isNil(openAVPermission)) return
        !openAVPermission &&
            checklistEventEmitter.emit(checklistKeys.AV_PERMISSION)
    }, [openAVPermission])

    useProfileSaver({
        status,
        err,
        userId,
    })

    const rightSection = err ? (
        <Troubleshoot error={err} userType={userType} />
    ) : (
        <SessionDeatils />
    )

    const showOnDesktop = !(isMobileOrIPad && err)

    return (
        <Container error={err}>
            {showOnDesktop && (
                <ParticipantDetails participants={participants} />
            )}
            {rightSection}
            <AVPermissionModal
                open={openAVPermission}
                close={() => setOpenAVPermission(false)}
            />
        </Container>
    )
}

Checklist.propTypes = {}

export default Checklist
